var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSendToDraftWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Send-to-Draft",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2, 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2,4.46666667 L5.2,9.8 L6.8,9.8 L6.8,4.46666667 C6.8,2.74777775 8.23199997,1.35555556 10,1.35555556 C11.768,1.35555556 13.2,2.74777775 13.2,4.46666667 L13.2,6.80017808 L14,7.68888889 L14.8,6.80017808 L14.8,4.46666667 C14.8,1.89222227 12.648,-0.2 10,-0.2 C7.35200005,-0.2 5.2,1.89222227 5.2,4.46666667 Z",
    id: "Vector",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.99,
    transform: "translate(10, 4.8) rotate(90) translate(-10, -4.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 3.48165941e-13,
    width: 6,
    height: 1.6,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0820536,8.77550824 L6.8,6.2 M9.0820536,8.77550824 L6.8,11.3510165",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    opacity: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    transform: "translate(7.941, 8.7755) rotate(-180) translate(-7.941, -8.7755)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "D",
    transform: "translate(2.3, 8)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.67967146,6 L0.583162218,6 L0.59137577,4.88736264 L2.67967146,4.88736264 C2.88501027,4.88736264 3.05270363,4.84203297 3.18275154,4.75137363 C3.31279945,4.66071429 3.40930869,4.5103022 3.47227926,4.30013736 C3.53524983,4.08997253 3.56673511,3.80906593 3.56673511,3.45741758 L3.56673511,2.53846154 C3.56673511,2.27472527 3.54962355,2.0521978 3.51540041,1.87087912 C3.48117728,1.68956044 3.42847365,1.54395604 3.35728953,1.43406593 C3.28610541,1.32417582 3.19164956,1.24381868 3.07392197,1.19299451 C2.95619439,1.14217033 2.816564,1.11675824 2.6550308,1.11675824 L0.562628337,1.11675824 L0.562628337,0 L2.6550308,0 C3.0054757,0 3.32375086,0.0570054945 3.60985626,0.171016484 C3.89596167,0.285027473 4.1430527,0.45260989 4.35112936,0.673763736 C4.55920602,0.894917582 4.71937029,1.16208791 4.83162218,1.47527473 C4.94387406,1.78846154 5,2.1456044 5,2.5467033 L5,3.45741758 C5,3.85576923 4.94387406,4.21222527 4.83162218,4.52678571 C4.71937029,4.84134615 4.55989049,5.10851648 4.35318275,5.3282967 C4.14647502,5.54807692 3.90143737,5.71497253 3.61806982,5.82898352 C3.33470226,5.94299451 3.02190281,6 2.67967146,6 Z M1.40451745,0 L1.40451745,6 L0,6 L0,0 L1.40451745,0 Z",
    id: "Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSendToDraftWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Send-to-Draft-White.b6e8304f805726ad85020d1c218aeea0.svg";